import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { FieldValueBase } from '../../../../utils/gql/generated/FieldValueBase';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UserSingleFieldValueFragment = { __typename?: 'AssetFieldValue', id: string, fieldType: Types.FieldTypeEnum, valueLength?: number | null, isValueTrimmed?: boolean | null, value: { __typename?: 'DateFieldValue' } | { __typename?: 'DerivedFieldValue' } | { __typename?: 'JsonFieldValue' } | { __typename?: 'LinkFieldValue' } | { __typename?: 'LongTextFieldValue' } | { __typename?: 'NumberFieldValue' } | { __typename?: 'RatingFieldValue' } | { __typename?: 'SelectFieldValue' } | { __typename?: 'SelectMultiFieldValue' } | { __typename?: 'TextFieldValue' } | { __typename?: 'ToggleFieldValue' } | { __typename?: 'UrlFieldValue' } | { __typename?: 'UserMultiFieldValue' } | { __typename?: 'UserSingleFieldValue', singleSelectedMember?: Array<{ __typename?: 'AccountUserGroupSelectMemberValue', id: string, displayName?: string | null } | { __typename?: 'UserSelectMemberValue', color?: string | null, displayImageUrl?: string | null, id: string, displayName?: string | null } | null> | null } | { __typename?: 'UsersFieldValue' }, fieldDefinition: { __typename?: 'ProjectFieldDefinition', id: string } };

export const UserSingleFieldValue = /*#__PURE__*/ gql`
    fragment UserSingleFieldValue on AssetFieldValue {
  ...FieldValueBase
  value {
    ... on UserSingleFieldValue {
      singleSelectedMember {
        id
        displayName
        ... on UserSelectMemberValue {
          color
          displayImageUrl
        }
      }
    }
  }
}
    ${FieldValueBase}` as unknown as DocumentNode<UserSingleFieldValueFragment, unknown>;

        

        
export const useUserSingleFieldValueFragment = (
  input: string | Omit<UseFragmentOptions<UserSingleFieldValueFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'AssetFieldValue' } };
    return input;
  })();

  return useFragment<UserSingleFieldValueFragment>({
    fragment: UserSingleFieldValue,
    fragmentName: 'UserSingleFieldValue',
    ...options,
  });
};
  
        